// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"61044335","422":"8017f441","451":"c64567f8","558":"0b605da4","654":"7d8eae2e","671":"ff9b275a","837":"57a7cb7d"}[chunkId] + ".chunk.js";
};